import {Permissions} from 'mattermost-redux/constants';
import {getLicense} from 'mattermost-redux/selectors/entities/general';
import {isCustomGroupsEnabled} from 'mattermost-redux/selectors/entities/preferences';
import {haveICurrentChannelPermission} from 'mattermost-redux/selectors/entities/roles';
import {type GlobalState} from 'types/store';

export const isGroupMentionAvailable = (state: GlobalState) => {
    const isPermissionEnabled = haveICurrentChannelPermission(state, Permissions.USE_GROUP_MENTIONS);

    if (!isPermissionEnabled) {
        return false;
    }

    const license = getLicense(state);
    const isLDAPEnabled = license?.IsLicensed === 'true' && license?.LDAPGroups === 'true';

    return isLDAPEnabled || isCustomGroupsEnabled(state);
};
